import Swiper from 'swiper/bundle';

/** Composante Carousel de Timtools */
export default class Carousel {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;

    // Options par défaut pour la librairie Swiper
    this.defaultOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el:
          this.element.querySelector('.swiper-pagination') ||
          '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl:
          this.element.querySelector('.swiper-button-next') ||
          '.swiper-button-next',
        prevEl:
          this.element.querySelector('.swiper-button-prev') ||
          '.swiper-button-prev',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
    };

    this.spaceBetween = {
      spaceBetween: 24,
    };

    this.init();
  }

  /**
   * Méthode d'initialisation
   */
  init() {
    let options = this.defaultOptions;

    // Gestion des paramètres différents lorsqu'on veut avoir
    switch (this.element.dataset.carousel) {
      case 'two':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
            },
          },
        };
        break;
      case '2.2':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 1.5,
              },
              768: {
                slidesPerView: 2.2,
              },
            },
          },
        };
        break;
      case 'three':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            },
          },
        };
        break;
      case 'four':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 4,
              },
            },
          },
        };
        break;
      case 'five':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
            },
          },
        };
        break;
      case 'six':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
              1100: {
                slidesPerView: 5,
              },
              1300: {
                slidesPerView: 6,
              },
            },
          },
        };
        break;
      case 'fade':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            effect: 'fade',
            simulateTouch: false,
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            loop: false,
          },
        };
        break;
      case 'footer':
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
              1400: {
                slidesPerView: 6,
              },
              1600: {
                slidesPerView: 7,
              },
              1800: {
                slidesPerView: 8,
              },
            },
            autoplay: {
              delay: 3000,
            },
          },
        };
        break;
      case 'nav':
        options = {
          ...this.defaultOptions,
          ...{
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            autoplay: false,
            pagination: {
              el:
                this.element.querySelector('.swiper-pagination') ||
                '.swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            mousewheel: false,
          },
        };
        break;
    }

    const swiper = new Swiper(this.element, options);

    // Setup timeline navigation for 'nav' carousel
    if (this.element.dataset.carousel === 'nav') {
      const timeline = document.querySelector('.timeline');
      const timelineItems = timeline
        ? timeline.querySelectorAll('.timeline-item')
        : [];

      if (timelineItems.length > 0) {
        // Click sur timeline-item pour naviguer
        timelineItems.forEach((item, index) => {
          item.addEventListener('click', () => {
            swiper.slideTo(index);
          });
        });

        // Fonction pour scroller la timeline intelligemment
        const scrollTimeline = (activeIndex) => {
          const activeItem = timelineItems[activeIndex];
          if (!activeItem || !timeline) return;

          // Mettre à jour les classes active
          timelineItems.forEach((item, i) => {
            if (i === activeIndex) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
            }
          });

          // Calculer le scroll pour garder 4 items visibles
          const itemWidth = activeItem.offsetWidth;
          const timelineWidth = timeline.offsetWidth;
          const maxScroll = timeline.scrollWidth - timelineWidth;

          // Commencer à scroller dès le 2ème item (index 1)
          if (activeIndex > 0 && maxScroll > 0) {
            const targetScroll = Math.min(activeIndex * itemWidth, maxScroll);
            timeline.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          } else {
            // Retour au début pour le premier item
            timeline.scrollTo({
              left: 0,
              behavior: 'smooth',
            });
          }
        };

        // Init: activer le premier item
        scrollTimeline(swiper.activeIndex);

        // Écouter les changements de slide
        swiper.on('slideChange', () => {
          scrollTimeline(swiper.activeIndex);
        });
      }
    }
  }
}
